import React, { useEffect, useState } from "react";
import { Table, Space, Form, Row, Col, Input, Select } from 'antd';
import TicketDetailsFormModal from './TicketDetailsFormModal';
import StringHelper from '../helpers/StringHelper';
import moment from 'moment-jalaali';
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { usePersistedStore } from "../../store/persisted-store";



export default function TicketsTable({ ticketTypes }) {


    const [form] = Form.useForm();
    const general = useGeneralStore();
    const loading = general.tickets.loading;
    const data = general.tickets.data;
    const { business } = usePersistedStore();
    const Token = business.currentBusiness.token
    const ContactUsTypeFilter = [...new Set(data.map(item => item.ContactUsTypeTitle))];

    const [searchValue, setSearchValue] = useState("");
    const [filterData, setFilterData] = useState([]);

    function handlePaste(event) {

        let paste = (event.clipboardData || window.clipboardData).getData("text");
        paste = paste.split("|").join(",");
        setSearchValue(paste)
    }
    useEffect(() => {
        if (ticketTypes === "close") {
            general.getTickets({
                id: 2,
                isTicket: true,
                fromDate: (moment(new Date()).format('YYYY/MM/DD')).replaceAll('/', '-'),
                toDate: (moment(new Date()).format('YYYY/MM/DD')).replaceAll('/', '-'),
            });
        }
    }, [ticketTypes]);

    useEffect(() => {
        setFilterData(data)
        form.resetFields();
    }, [data]);

    useEffect(() => {
        if (searchValue === "") return setFilterData(data)
    }, [searchValue]);

    const searchHandlerInput = (event) => {
        form.setFieldsValue({ contactTypeId: null });
        const { value } = event.target;
        setSearchValue(value);
        if (value) {
            const englishNum = StringHelper.getEnglishNum(value)

            const filtered = data && data?.filter((item) => {
                return item.FullName.includes(value) ||
                    item.Id.toString().includes(englishNum) ||
                    item.Username.includes(Number(englishNum)) ||
                    item.ContactUsTypeTitle.includes(value)

            }
            )
            if (filtered) setFilterData(filtered)
        }
    }

    const contactUsTypeFilter = typeSearch => {
        form.setFieldsValue({ search: null });
        if (typeSearch === null) {
            setFilterData(data)
        } else {
            const contactUsName = data.filter(contactType =>
                contactType.ContactUsTypeTitle.includes(typeSearch))
            setFilterData(contactUsName)
        }

    };

    const columns = [
        {
            title: '',
            dataIndex: "operation",
            ellipsis: true,
            width: 80,
            key: "operation",
            render: (_, record) =>

                data.length >= 1 && (
                    <Space size="middle">
                        <button type="primary" htmltype="submit" className="btn btn-warning waves-effect waves-light"
                            onClick={() => {
                                general.getTicketDetails(record.Id);
                                general.ToggleDetailsTicketFormModal(true);
                            }}>
                            <i className="far fa-eye font-size-14 align-middle "></i>
                        </button>
                    </Space>
                )
        },
        {
            title: 'کد تیکت',
            dataIndex: 'Id',
            key: "Id",
            width: 100,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: 'نام',
            width: 170,
            dataIndex: 'FullName',
            key: "FullName",
        },
        {
            title: 'نام کاربری',
            width: 150,
            dataIndex: 'Username',
            key: "Username",

        },
        {
            title: 'موضوع',
            width: 200,
            dataIndex: 'ContactUsTypeTitle',
            key: "ContactUsTypeTitle",
        },
        {
            title: 'تاریخ ثبت',
            width: 140,
            dataIndex: 'CreateDate',
            key: "CreateDate",
            render: (text) => text && StringHelper.getFarsiNum(moment(text).format('HH:mm - jYYYY/jM/jD')),
        },
        {
            title: 'تاریخ آخرین بروزرسانی',
            width: 170,
            dataIndex: 'LastMessageDateTime',
            key: "LastMessageDateTime",
            render: (text) => text && StringHelper.getFarsiNum(moment(text).format('HH:mm - jYYYY/jM/jD')),
        },

    ];

    return (
        <div className="animated fadeIn">
            <Form form={form}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item
                            onKeyPress={(e) => (e.key === 'Enter' && "")}
                            name="search" label="جست و جو:"
                            className="search-lable"
                            style={{ marginBottom: "-15px" }}>
                            <Input
                                value={searchValue}
                                onPaste={handlePaste}
                                onChange={e => searchHandlerInput(e)}
                                className="table-search"
                                placeholder="بر اساس کد تیکت، نام، نام کاربری و موضوع"
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={12}>
                        <Form.Item
                            label="فیلتر بر اساس موضوع"
                            name="contactTypeId"
                            style={{ marginTop: "7px" }}>
                            <Select
                                onChange={contactUsTypeFilter}
                                defaultValue={null}
                                className="BusinessSupport-filter"
                                placeholder="موضوع">
                                <Select.Option value={null} >همه موضوع ها</Select.Option>
                                {ContactUsTypeFilter.length && ContactUsTypeFilter.map((name, index) => {
                                    return <Select.Option key={index} value={name}>{name}</Select.Option>
                                })}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                style={{ overflowX: 'scroll', width: "100%" }}
                className="custom-table"
                showHeader={true}
                columns={columns}
                loading={loading}
                scroll={true}
                pagination={true}
                dataSource={filterData}
                rowKey="Id"

            />
            <TicketDetailsFormModal />
        </div>
    )
}